import {mixpanel} from "../util/mixpanel";
import {setupDashboard, manager} from "../weather/weather_manager.js";
import {currentTime} from "../datetime/time.js";
import {load_textures} from "../weather/weather_generators/sprites.js";
import {tick_fps} from "../util/fps.js";
import {setupSettings} from "../settings/settings";
import {renderCalendar} from "../calendar/calendar";
import {hideLoader} from "../util/loaders/loader";
import * as Sentry from "@sentry/browser";
import {getLocation} from "../util/geo_location";
import {setHolidays} from "../calendar/holidays";
import {applyHoroscope} from "../util/horoscope";
import {applyBackgroundImage} from "../sunrise/background_img";
import {applyGoogleCalendar} from "../calendar/googleint/google_calendar";
import {debounce} from "../util/resize";


mixpanel.init('bd4a6f943ed86972f256eb9b99d8827c');

Sentry.init({
    dsn: "https://3eccca3b40f74d45bb02fdc09ade2eec@o1391215.ingest.sentry.io/6712444",
    tracesSampleRate: 0.5,
});
Sentry.setContext("locale", {
    language: window.navigator.language
});

async function scheduleDashboardTimeout() {
    // Wait for setupDashboard to complete
    try {
        await setupDashboard();
    } catch (e) {
        console.log(e);
    }
    setTimeout(scheduleDashboardTimeout, 30 * 60 * 1000); // 30 minutes
}

async function updateElements() {
    renderCalendar();
    await setHolidays();
    await applyHoroscope();
    await applyBackgroundImage();
    await applyGoogleCalendar();
}

async function initializeApp() {
    try {
        await Promise.all([
            getLocation(),
            load_textures(),
            manager.init()
        ]);

        await scheduleDashboardTimeout();

        await Promise.all([
            setupSettings(),
            hideLoader(),
        ]);

        requestAnimationFrame(tick);
        requestAnimationFrame(tick_fps);
        await updateElements();
    } catch (error) {
        console.error(error);
    }
}

initializeApp();


window.addEventListener('resize', async function (event) {
    await manager.resize();
}, true);

function tick(timestamp) {
    manager.tick(timestamp);
    requestAnimationFrame(tick);
}

setInterval(updateElements, 60 * 60 * 1000); // 1 hour
setInterval(currentTime, 60000); // 1 minute

window.addEventListener('resize', debounce(() => {applyBackgroundImage();}, 300));

export default {initializeApp};
